import React from 'react';
import ReactDOM from 'react-dom';
import Functionality from './birthday-reminder/reminder';

ReactDOM.render(
  <React.StrictMode>
    <Functionality />
  </React.StrictMode>,
  document.getElementById('root')
);
